import { render, staticRenderFns } from "./StepSummary.vue?vue&type=template&id=15a37344&"
import script from "./StepSummary.vue?vue&type=script&lang=js&"
export * from "./StepSummary.vue?vue&type=script&lang=js&"
import style0 from "./StepSummary.vue?vue&type=style&index=0&id=15a37344&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports